import React, { useEffect, useState } from "react";
import { Getdata } from "../helpers/api.service";
import { useParams } from "react-router-dom";

const Policies = () => {
  let [data, setData] = useState([]);
  let [loading, setLoading] = useState(false);

  const { id } = useParams();
  console.log('id::::U:::::::::uUUUu: ', id);

  const fetchData = () => {
    setLoading(true);
    Getdata(
      process.env.REACT_APP_URL +
        `/front/policy/show/${process.env.REACT_APP_SUBDOMAIN}${id}`
    )
      .then((res) => {
        console.log("Terms & condition:::::::::::::::::::::", res);
        if (res?.data) {
          setData(res.data);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching news:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if(id) fetchData();
  }, [id]);

  return (
    <div className="py-16">
      <h2 className="text-f100 text-primary_main text-center font-bold mb-12">
        {data.title}
      </h2>
      <div className="max-w-sm md:max-w-lg lg:max-w-3xl xl:max-w-[60rem] 2xl:max-w-6xl mx-auto text-start ">
        <div dangerouslySetInnerHTML={{ __html: data?.text }} />
      </div>
    </div>
  );
};

export default Policies;

// <div className="max-w-sm md:max-w-lg lg:max-w-3xl xl:max-w-[60rem] 2xl:max-w-6xl mx-auto text-start ">
//   {/* Intro Paragraph */}
//   <p className="mb-6 text-sm sm:text-base leading-relaxed">
//     We are committed to protecting the privacy of our students, parents, staff,
//     and website visitors. This Privacy Policy outlines how we collect, use,
//     store, and safeguard your personal information in compliance with Kenya’s
//     Data Protection Act and other applicable regulations.
//   </p>

//   {/* Terms List */}
//   <ol className="space-y-6 list-decimal list-inside">
//     <li>
//       <span className="font-bold mb-2 text-base sm:text-[24px]">
//         Information We Collect
//       </span>
//       <p className="pt-2 text-sm sm:text-base">
//         {" "}
//         We may collect the following types of personal information through our
//         website forms, admissions process, or other interactions:
//       </p>
//       <ul className="list-disc list-inside text-sm sm:text-base space-y-1">
//         <li>Student name, age, date of birth, and academic history</li>
//         <li>
//           Parent/guardian name, contact details, and relationship to student
//         </li>
//         <li>Email addresses and phone numbers</li>
//         <li>
//           Preferences or inquiries regarding admission, events, or services
//         </li>
//         <li>Website usage data (via cookies or analytics)</li>
//       </ul>
//     </li>

//     <li>
//       <span className="font-bold mb-2 text-base sm:text-[24px]">
//         How We Use Your Information
//       </span>
//       <p className="pt-2 text-sm sm:text-base">
//         We use the information we collect for the following purposes:
//       </p>
//       <ul className="list-disc list-inside text-sm sm:text-base space-y-1">
//         <li>To respond to inquiries and process admissions</li>
//         <li>To communicate important school updates or events</li>
//         <li>To personalize your experience on our website</li>
//         <li>For administrative, safety, or legal obligations</li>
//         <li>To improve our educational offerings and website functionality</li>
//       </ul>
//     </li>

//     {/* 3. Data Sharing and Disclosure */}
//     <li>
//       <span className="font-bold mb-2 text-base sm:text-[24px]">
//         Data Sharing and Disclosure
//       </span>
//       <p className="pt-2 text-sm sm:text-base">
//         We do not sell, rent, or trade your personal information. However, we
//         may share data in the following limited situations:
//       </p>
//       <ul className="list-disc list-inside text-sm sm:text-base space-y-1">
//         <li>
//           With service providers (e.g., hosting, email tools) under strict
//           confidentiality
//         </li>
//         <li>When required by Kenyan law or in response to legal requests</li>
//         <li>With your consent, for specific programs or communications</li>
//       </ul>
//     </li>

//     {/* 4. Data Security */}
//     <li>
//       <span className="font-bold mb-2 text-base sm:text-[24px]">
//         Data Security
//       </span>
//       <p className="pt-2 text-sm sm:text-base">
//         We implement reasonable administrative, technical, and physical
//         safeguards to protect your personal data from unauthorized access, loss,
//         misuse, or disclosure. These include secure servers, password-protected
//         systems, and access controls.
//       </p>
//     </li>

//     {/* 5. Cookies and Website Analytics */}
//     <li>
//       <span className="font-bold mb-2 text-base sm:text-[24px]">
//         Cookies and Website Analytics
//       </span>
//       <p className="pt-2 text-sm sm:text-base">
//         Our website may use cookies and third-party tools (like Google
//         Analytics) to understand visitor behavior and improve user experience.
//         You can disable cookies in your browser settings if you prefer.
//       </p>
//     </li>

//     {/* 6. Children’s Privacy */}
//     <li>
//       <span className="font-bold mb-2 text-base sm:text-[24px]">
//         Children’s Privacy
//       </span>
//       <p className="pt-2 text-sm sm:text-base">
//         We are committed to protecting the privacy of children. Personal
//         information about students is collected only with parental or guardian
//         consent and used strictly for school-related purposes.
//       </p>
//     </li>

//     {/* 7. Your Rights */}
//     <li>
//       <span className="font-bold mb-2 text-base sm:text-[24px]">
//         Your Rights
//       </span>
//       <p className="pt-2 text-sm sm:text-base">You have the right to:</p>
//       <ul className="list-disc list-inside text-sm sm:text-base space-y-1">
//         <li>Access the personal data we hold about you</li>
//         <li>Request correction or deletion of your information</li>
//         <li>Withdraw consent for certain types of data processing</li>
//         <li>
//           Lodge a complaint with the Office of the Data Protection Commissioner
//           (ODPC) in Kenya
//         </li>
//       </ul>
//     </li>

//     {/* 8. Updates to This Policy */}
//     <li>
//       <span className="font-bold mb-2 text-base sm:text-[24px]">
//         Updates to This Policy
//       </span>
//       <p className="pt-2 text-sm sm:text-base">
//         We may update this Privacy Policy occasionally to reflect changes in our
//         practices or legal obligations. Any changes will be posted on this page
//         with a new effective date.
//       </p>
//     </li>
//   </ol>
// </div>
